import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { MultiTenancyConstants } from '@vsolv/core/multi-tenant/domain';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { previewTenantId } from './environments/preview-tenant-id';

if (environment.production) {
  enableProdMode();
}

// Preview builds pin a staging tenant since the preview domain can't be resolved to one by the API
if (previewTenantId && !sessionStorage.getItem(MultiTenancyConstants.TENANT_ID_LOCAL_STORAGE_KEY)) {
  sessionStorage.setItem(MultiTenancyConstants.TENANT_ID_LOCAL_STORAGE_KEY, previewTenantId);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
